import { BlobServiceClient } from "@azure/storage-blob";
import MultimediaHelper from "./MultimediaHelper";
import { Capacitor } from "@capacitor/core";

//@todo create a way for local helpers to subscribe to changes in the global
export default class GlobalMultimediaHelper {
  constructor() {
    /**
     * Format containerName -> {finishCallback, progressCallback}
     */
    this.subscribers = {};
    this.horseListSubscribers = {};

    this.uploadQueue = [];
    this.blobServiceClient = new BlobServiceClient(
      `https://${MultimediaHelper.accountName}.blob.core.windows.net?${MultimediaHelper.sasToken}`
    );
    this.isUploading = false;
    this.horseList = [];
  }

  subscribeToHorseList(callback) {
    this.horseListSubscribers.push(callback);
    callback(this.horseList);
  }
  notifyHorseListSubscribers() {
    this.horseListSubscribers.forEach((callback) => {
      if (typeof callback == "function") {
        callback(this.horseList);
      }
    });
  }
  setHorseList(horseList) {
    this.horseList = horseList;
    this.notifyHorseListSubscribers();
  }

  subscribeToUpload(
    containerName,
    finishCallback,
    progressCallback,
    refreshUploadQueue
  ) {
    if (!this.subscribers[containerName]) {
      this.subscribers[containerName] = [
        {
          finishCallback,
          progressCallback,
          refreshUploadQueue,
        },
      ];
      return;
    }

    this.subscribers[containerName].push({
      finishCallback,
      progressCallback,
      refreshUploadQueue,
    });
  }

  notifySubscribersProgress(containerName, file_name, progress) {
    console.log(
      "notifySubscribersProgress",
      containerName,
      file_name,
      progress,
      this.subscribers
    );
    if (!this.subscribers[containerName]) return;
    this.subscribers[containerName].forEach((subscriber) => {
      //check if the subscriber has a progressCallback
      if (!subscriber.progressCallback) return;
      //call the progressCallback
      // file_name, percent, target_request, callback

      if (typeof subscriber.progressCallback == "function") {
        subscriber.progressCallback(containerName, file_name, progress);
      }
    });
  }

  notifySubscribersFinish(containerName, file_name, dbxItem) {
    console.log("notifySubscribersFinish", containerName, file_name, dbxItem);
    console.log(this.subscribers);
    if (!this.subscribers[containerName]) return;
    this.subscribers[containerName].forEach((subscriber) => {
      if (typeof subscriber.finishCallback == "function") {
        subscriber.finishCallback(containerName, file_name, dbxItem);
      }
    });
  }

  /**
   * A function that adds files to the upload queue.
   *
   * @param {string} request_origin The location.href from which the files were added.
   * @param {Array<object>} files  List of files to be added to the upload queue.
   */
  addToUploadQueue(containerName, files, path, doneCallback, progressCallback) {
    this.uploadQueue.push(
      ...files.map((file) => {
        return {
          containerName,
          file,
          path: path,
          doneCallback,
          progressCallback,
        };
      })
    );
    this.subscribers[containerName].forEach((subscriber) => {
      if (typeof subscriber.refreshUploadQueue == "function") {
        subscriber.refreshUploadQueue(containerName, this.uploadQueue);
      }
    });

    if (this.isUploading) return;
    this.isUploading = true;
    this.startUploadQueueElements();
  }

  /**
   * A function that takes all the elements from the queue, uploads them and calls the respective callbacks.
   */
  startUploadQueueElements = async () => {
    if (this.uploadQueue.length <= 0) {
      this.isUploading = false;
      return;
    }

    const el = { ...this.uploadQueue[0] };
    this._uploadWthSingleRequest(
      el.containerName,
      el.file,
      async (dbxItem) => {
        console.log("dbxItem", dbxItem);
        console.log("thumbnail", dbxItem.thumbUrl);
        if (dbxItem == null) {
          this.notifySubscribersFinish(el.file.fileName, null);
          this.uploadQueue.shift();
          this.startUploadQueueElements();
        } else {
          dbxItem.path_display = dbxItem.fileName;
          dbxItem.type = MultimediaHelper.getTypeItem(dbxItem);

          // const url = dbxItem.url;
          const encodedFileName = encodeURIComponent(dbxItem.fileName);
          const signedUrl = dbxItem.url;

          dbxItem.path_display = dbxItem.fileName;
          dbxItem.fullUrl = signedUrl;
          dbxItem.thumbUrl =
            MultimediaHelper.getTypeItem(dbxItem) ===
            MultimediaHelper.TYPE_VIDEO
              ? await this.generateThumbnail(signedUrl)
              : signedUrl;
          dbxItem.imageUrl = signedUrl;
          dbxItem.name = dbxItem.fileName;
          this.uploadQueue.shift();
          this.notifySubscribersFinish(
            el.containerName,
            dbxItem.fileName,
            dbxItem
          );
          this.startUploadQueueElements();
        }
      },
      el.path,
      el.progressCallback
    );
  };

  generateThumbnail(videoUrl, seekTime = 1) {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.crossOrigin = "anonymous"; // Ensure the video is fetched with CORS headers

      video.src = videoUrl;
      video.preload = "metadata";
      video.currentTime = 0.001;

      video.addEventListener("seeked", () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext("2d");

        // Draw the video frame to the canvas
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Get the image data URL from the canvas
        const imageUrl = canvas.toDataURL("image/png");
        resolve(imageUrl);
      });

      video.addEventListener("error", (error) => {
        resolve(videoUrl);
        // reject(`Error loading video: ${error.message}`);
      });
    });
  }

  /**
   * Function called when Android/IOS wrappers finish uploading one photo from the upload queueu
   * @param file_name the name of the file finished uploading
   * @param target_request the location.href of the upload item
   * @param dbxPath the path_display of the uplaod element, used to reconstruct the element from database
   */
  onUploadDoneCallback(
    file_name,
    target_request,
    dbxPath,
    callback,
    containerName
  ) {
    console.log("onUploadDoneCallback", file_name, target_request);
    let x = this.uploadQueue.find(
      (el) => el.fileName == file_name && el.containerName == containerName
    );
    if (!x) return;
    let dbxItem = { path_display: dbxPath, name: file_name };
    console.log("OK");
    dbxItem.type = MultimediaHelper.getTypeItem(dbxItem.fileName);

    const encodedFileName = encodeURIComponent(dbxItem.fileName);
    const url = `https://${MultimediaHelper.accountName}.blob.core.windows.net/${dbxItem.container}/${encodedFileName}?${MultimediaHelper.sasToken}`;

    dbxItem.path_display = dbxItem.fileName;
    dbxItem.fullUrl = url;
    dbxItem.thumbUrl = url;
    dbxItem.imageUrl = url;
    console.log(dbxItem);
    this.notifySubscribersFinish(containerName, file_name, dbxItem);
    this.removeElementFromUploadQueue(file_name, containerName);
  }

  onUploadProgressCallback(file_name, percent, callback, containerName) {
    let x = this.uploadQueue.findIndex(
      (el) => el.file.fileName == file_name && el.containerName == containerName
    );
    // if (x >= 0) {
    //   this.uploadQueue[x].progressCallback = callback;
    // }
    this.notifySubscribersProgress(containerName, file_name, percent);
  }
  /**
   * Function to remove an element from the queue upload queue.
   *
   * @param name The name of the file to be removed
   * @param containerName The name of the container to be removed from
   */
  removeElementFromUploadQueue(name, containerName) {
    this.uploadQueue = this.uploadQueue.filter(
      (el) => el.fileName != name || el.containerName != containerName
    );
  }

  _uploadWthSingleRequest = async (
    containerName,
    file, // { fileName, mimeType, media_path?, actual_image? }
    finishCallback, // your callback (request_origin, fileName, dbxItem|null)
    containerPath, // blob “folder” prefix, e.g. static_path or this.path
    progressCallback // optional progress callback (request_origin, fileName, pct)
  ) => {
    console.log("Upload file to container", containerName);
    const containerClient =
      this.blobServiceClient.getContainerClient(containerName);

    const { sasToken } = MultimediaHelper;
    try {
      // ── 1) Build Azure client ───────────────────────────────────────
      // optional folder prefix
      const blobName = file.fileName;
      const blockClient = containerClient.getBlockBlobClient(blobName);

      // ── 2) Turn your pick into a Blob ───────────────────────────────
      let blob;
      if (file.actual_image && Capacitor.getPlatform() === "web") {
        console.log("actual_image", file.actual_image);
        // Web: you already provided a File/Blob
        blob = file.actual_image;
      } else if (file.media_path) {
        // Mobile: fetch the native URI
        let uri = file.media_path;
        if (Capacitor.getPlatform() === "ios") {
          // convert file:// → WKWebView‐accessible URL
          uri = Capacitor.convertFileSrc(uri);
        }
        blob = await fetch(uri).then((r) => r.blob());
      } else {
        throw new Error("No valid source (actual_image or media_path)");
      }

      // ── 3) Upload with progressCallback ─────────────────────────────
      await blockClient.uploadData(blob, {
        onProgress: (ev) => {
          const pct = ev.loadedBytes / blob.size;
          if (typeof progressCallback === "function") {
            //file_name, percent, target_request, callback
            this.onUploadProgressCallback(
              file.fileName,
              pct,
              progressCallback,
              containerName
            );
          }
        },
      });

      console.log("Upload complete", file.fileName);
      // ── 4) Build your dbxItem and call finishCallback ───────────────
      const dbxItem = {
        fileName: file.fileName,
        path_display: file.fileName,
        url: blockClient.url,
        fullUrl: blockClient.url + `?${sasToken}`,
        thumbUrl: null, // you can fill this later if you want
        etag: undefined, // add more metadata from `resp` if desired
        lastModified: undefined,
        container: MultimediaHelper.containerName,
      };
      // if you need a thumbnail for videos, do it here:
      if (
        MultimediaHelper.getTypeItem(dbxItem) === MultimediaHelper.TYPE_VIDEO
      ) {
        dbxItem.thumbUrl = await this.generateThumbnail(dbxItem.fullUrl);
      } else {
        dbxItem.thumbUrl = dbxItem.fullUrl;
      }
      console.log("[finished upload]dbxItem", dbxItem);
      finishCallback(dbxItem);
    } catch (err) {
      console.error("Upload failed", err);
      // on error, signal done with null
      finishCallback(null);
    }
  };
}
